import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'; // Importación actualizada
import { Router } from '@angular/router';
import { EncuestasServiceService } from 'src/app/services/encuestas-service.service';

@Component({
    selector: 'app-indicadores',
    templateUrl: './indicadores.component.html',
    styleUrls: ['./indicadores.component.scss'],
    standalone: false
})
export class IndicadoresComponent implements OnInit {

  public isLoading: boolean = false;
  public laravelapiStorage: any;
  public t: any;
  public indicadores: any = [];
  public year: number = 2024;

  constructor(
    private route: Router,
    private dialog: MatDialog, // Cambiado aquí
    private encuestasService: EncuestasServiceService,
  ) { }

  ngOnInit(): void {
    this.getIndicadoresDeResultados(this.year); // Se puede usar la variable year directamente
  }

  public getIndicadoresDeResultados(year: number) {
    console.log(year);
    this.isLoading = true;
    this.encuestasService.getIndicadoresDeResultados(year).subscribe(result => {
      console.info(result);
      if (result.status === 1) {
        this.indicadores = [];

        result.data.forEach((item: any) => {
          const dimension = item.dimension;

          // Recorre cada indicador dentro de la dimensión
          Object.keys(item.indicadores).forEach(key => {
            const indicador = item.indicadores[key];
            this.indicadores.push({
              dimension: dimension,
              nombreEncuesta: indicador.nombreEncuesta,
              tipoDeIndicador: indicador.tipoDeIndicador,
              componenteDeLaIntervencion: indicador.componenteDeLaIntervencion,
              resultadoDeEvaluacion: indicador.resultadoDeEvaluacion
            });
          });
        });

        console.log(this.indicadores);
      }
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.error(error); // Cambiado a console.error para mejor manejo de errores
    });
  }
}
